  import App from './modules/app'


window.addEventListener('DOMContentLoaded', (event) => {
  var app = new App()
});
